module.exports = __webpack_public_path__ + "img/output-3.fb3de480.png";